/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 * @file 全局header
 * @author liwei.zhu
 */
import React, { Component, Fragment } from 'react';
import { inject } from 'mobx-react';
import PropTypes from 'prop-types';
import { action } from 'mobx';
import { Badge, Layout, Menu, Icon, Modal, Popover } from 'antd';
import TextButton from 'src/components/form/textButton';
import request from 'src/utils/request';
import tryCatch from 'src/utils/tryCatch';
import styles from './index.less';

const SubMenu = Menu.SubMenu;
const { Header } = Layout;

const MESSAGE_DELAY = 1000 * 60;

@inject('globalStore')
export default class GlobalHeader extends Component {
    static propTypes = {
        globalStore: PropTypes.shape({
            accountInfo: PropTypes.shape({}).isRequired,
            logout: PropTypes.func.isRequired,
        }).isRequired,
    };

    state = {
        msgCount: 0,
    };

    componentDidMount() {
        this.fetchData();
        this.timer = setInterval(this.fetchData, MESSAGE_DELAY);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    fetchData = async () => {
        const { globalStore } = this.props;
        if (globalStore && globalStore.accountInfo && globalStore.accountInfo.username) {
            const [err, resp] = await tryCatch(() =>
                request('/api/message/arbitrationCount', {
                    method: 'POST',
                    data: {
                        username: globalStore.accountInfo.username,
                    },
                })
            );

            if (`${resp.code}` === '0' && resp.data) {
                this.setState({ msgCount: resp.data });
            } else {
                this.setState({ msgCount: 0 });
            }
        }
    };

    @action
    handleMenuClick = async ({ key }) => {
        // 个人信息下拉菜单点击事件
        if (key === 'logout') {
            // 登出
            this.props.globalStore.logout();
        } else if (key === 'changePass') {
            // 修改密码
            const Info = Modal.info({
                title: '重置密码',
                content: (
                    <div>
                        <span>修改密码请至</span>
                        <TextButton
                            items={[
                                {
                                    text: '微盟LDAP密码修改页',
                                    onClick: () => {
                                        window.open('http://ldap-self.weimob.com/u.html', '_blank');
                                        Info.destroy();
                                    },
                                },
                            ]}
                        />
                    </div>
                ),
            });
        }
    };

    jumpToSafeguardList = () => {
        this.props.history.push('/safeguard/list', { refundStatus: 7 });
    };

    render() {
        const { accountInfo } = this.props.globalStore;
        const { msgCount } = this.state;

        const userName = (
            <Fragment>
                <span className={styles.userInfo}>{accountInfo.givenName}</span>
                <Icon type="down" className={styles.userInfoDown} />
            </Fragment>
        );

        const content = (
            <div className={styles.msgBox}>
                {msgCount ? (
                    <p className={styles.clickable} onClick={this.jumpToSafeguardList}>
                        有<span className={styles.num}>{msgCount}</span>笔维权仲裁，请及时处理 &gt;
                    </p>
                ) : (
                    <div className={styles.emptyMsg} />
                )}
            </div>
        );
        return (
            <Header className={styles.header}>
                <Popover content={content} title={msgCount > 0 ? `您有${msgCount}条重要通知` : '暂无未读通知'}>
                    <div className={styles.message}>
                        消息
                        <Badge count={msgCount} dot />
                    </div>
                </Popover>
                <Menu mode="horizontal" className={styles.userInfoWrapper} onClick={this.handleMenuClick}>
                    <SubMenu key="1" className={styles.subMenuStyle} title={userName}>
                        <Menu.Item className={styles.menuItem} key="changePass">
                            <Icon type="edit" />
                            <span>修改密码</span>
                        </Menu.Item>
                        <Menu.Item className={styles.menuItem} key="logout">
                            <Icon type="logout" />
                            <span>退出登录</span>
                        </Menu.Item>
                    </SubMenu>
                </Menu>
            </Header>
        );
    }
}
